import { xCheck } from "./xCheck.js";
import { xPadding } from "./xPadding.js";
/**
 * This function calculates a rolling average
 * @param array - array
 * @param fct - callback function that from an array returns a value
 * @param options - options
 */
export function xRolling(array, fct, options = {}) {
    xCheck(array);
    if (typeof fct !== 'function') {
        throw new TypeError('fct must be a function');
    }
    const { window = 5, padding = {} } = options;
    const { size = window - 1, algorithm, value } = padding;
    const padded = xPadding(array, { size, algorithm, value }); // ensure we get a copy and it is float64
    const newArray = [];
    for (let i = 0; i < padded.length - window + 1; i++) {
        // we will send a view to the original buffer
        newArray.push(fct(padded.subarray(i, i + window)));
    }
    return newArray;
}
//# sourceMappingURL=xRolling.js.map